export default __webpack_public_path__ + "static/media/favicon-light.bf5f9a34.svg";